// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"461":"694d32821363dc480961","489":"74ddb638bbc715770012","524":"731a534598dc73e34400"}[chunkId] + ".css";
};